import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  PLATFORM_ID,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChange,
  SimpleChanges,
} from '@angular/core'
import {MatIconModule} from '@angular/material/icon'
import { CommonModule, isPlatformBrowser } from '@angular/common'
import { RouterModule, Router } from '@angular/router'
import { AuthService } from '../../pages/auth/auth.service'
import { Subscription } from 'rxjs'
import { HomeComponent } from '../home/home.component'
import { MatToolbarModule } from '@angular/material/toolbar'


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule,MatIconModule, HomeComponent, MatToolbarModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit, OnChanges, OnDestroy {
  @Output() typeClick = new EventEmitter<string>();
  @Output() clickSide = new EventEmitter<any>();
  @Input() dataNav: any;
  @Input() link:any;
  isAuth = false;
  private userSub : Subscription
  isAuthenticated = false
  showMore = false;
  widthScreen = 0
  fontSize: any
  buttonColor = false
  className!: string
  @Input() widhScreen:any
  showNav = false;
  token:any;
  sidenav = false;
  dark = 'dark'
  file: any
  iconSocial = {
    insta: '../../../assets/nft/insta.png',
    twet: '../../../assets/nft/tweet.png',
    figma: '../../../assets/nft/figma.png',
    sun: '../../../assets/nft/sun.png',
    github: '../../../assets/nft/github.png'
  }
  @Output() styleBg = new EventEmitter<string>()
  username: any;
  logout = false

  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.userSub = new Subscription();
    if (isPlatformBrowser(this.platformId)) {
      this.widthScreen = window.innerWidth
    }

    window.addEventListener('storage', this.storageChanged.bind(this) )
  }

  ngOnInit() {
    this.userSub = this.authService.user.subscribe((user: any) => {
      this.isAuth = !!user
      console.log(this.isAuth)
    })
    this.username = localStorage.getItem('username')
    this.username?.slice(4.1)
    this.token = localStorage.getItem('token')

    this.widthScreen > 1280
      ? (this.fontSize = '60px')
      : (this.fontSize = '40px')
  }

  clickSideBar(){
    this.sidenav = !this.sidenav;
    this.clickSide.emit(this.sidenav)
    console.log(this.sidenav)
  }

  storageChanged(event: any){
    if(event.key == 'username' && event.newValue){
      this.username = event.newValue;
      location.reload
    }
  }

  doShowNav(){
    this.showNav = !this.showNav
  }

  login(){
    this.router.navigate(['login'])
  }

  ngOnChanges(simple: SimpleChanges){
    if(simple.username){
      location.reload()
    }
  }

  ngOnDestroy(): void {
      this.userSub.unsubscribe()
  }

  changeColor() {
    this.buttonColor = !this.buttonColor
  }
  doChange(color: string) {
    switch (color) {
      case 'dark':
        this.className = 'dark' ? 'dark' : 'blueviolet'
        break
      case 'white':
        this.className = 'white' ? 'white' : 'blueviolet'
        break
      case 'blue':
        this.className = 'blue' ? 'blue' : 'blueviolet'
        break
      default:
        this.className = 'blueviolet'
    }
    console.log(this.className)
  }
  downloadCv() {
    this.file = '../../../assets/file/cvterbaru-dikompresi new.pdf'
    window.open(this.file)
  }

  dologout(){
    this.logout = !this.logout;
  }
  out(){
    setTimeout(() => {
    localStorage.removeItem('username')
     localStorage.removeItem('token')
     localStorage.removeItem('role')
     localStorage.clear()
     location.reload();
    }, 2000)
  }


  // ngOnDestroy(): void {
  //     this.authService.user.unsubscribe()
  // }

  toDarkMode(color: string){
    // console.log(color, 'child');
    this.styleBg.emit(color)
  }
  onClickButtonNavbar(type:string){
    // console.log(type)
    this.typeClick.emit(type)
  }
}
